import { URLHandler } from "src/services/URLHandler.ts";
import { ValidationMessage } from "src/components/QuestionnaireForm/FormProperty/validationTypes";
import { whereAmI } from "src/services/urlSwitcher";

export const resolveUrlForProperty = (
    params: Record<string, string | number | undefined>,
    validationMessage: ValidationMessage,
    pathname: string,
) => {
    const { companyId, activeCompanyId, productId, packagingId, ingredientId, ssqId, campaignId, scoreId, supplierId } =
        params;

    const myLocation = whereAmI({ url: pathname });

    const ssqSsqHeadingId = validationMessage.hint?.ssqSsqHeadingId;
    const parentSsqSsqHeadingId = validationMessage.hint?.parentSsqSsqHeadingId;
    const propertyId = validationMessage.hint?.propertyId;

    const headingId = parentSsqSsqHeadingId ? parentSsqSsqHeadingId : ssqSsqHeadingId;
    if (!ssqSsqHeadingId || !propertyId || !headingId) {
        return null;
    }

    let baseUrl;
    if (myLocation.inCompany && ssqId && campaignId && companyId && scoreId) {
        baseUrl = URLHandler.company.questionnaireHeading(
            Number(companyId),
            Number(ssqId),
            Number(campaignId),
            String(scoreId),
            Number(headingId),
        );
    } else if (myLocation.inProduct && companyId && productId) {
        baseUrl = URLHandler.product.ssqHeading(
            Number(companyId),
            Number(productId),
            Number(activeCompanyId),
            Number(headingId),
        );
    } else if (myLocation.inIntermediateProduct && companyId && productId) {
        baseUrl = URLHandler.intermediateProduct.ssqHeading(
            Number(companyId),
            Number(productId),
            Number(activeCompanyId),
            Number(headingId),
        );
    } else if (myLocation.inIngredients && companyId && ingredientId && supplierId) {
        baseUrl = URLHandler.ingredient.ssqHeading(
            Number(companyId),
            Number(ingredientId),
            Number(supplierId),
            Number(headingId),
        );
    } else if (myLocation.inPackagings && companyId && packagingId) {
        baseUrl = URLHandler.packaging.ssqHeading(Number(companyId), Number(packagingId), Number(headingId));
    }

    if (!baseUrl) {
        return null;
    }

    if (!propertyId) {
        return baseUrl;
    }

    // If there's a parent heading, we need to include the subheading ID to expand form accordion
    if (parentSsqSsqHeadingId) {
        return `${baseUrl}#subheadingId=${ssqSsqHeadingId}&propertyId=${propertyId}`;
    }

    return `${baseUrl}#propertyId=${propertyId}`;
};
